import { render, staticRenderFns } from "./TfaCode.vue?vue&type=template&id=189434d8&scoped=true&"
import script from "./TfaCode.vue?vue&type=script&lang=js&"
export * from "./TfaCode.vue?vue&type=script&lang=js&"
import style0 from "./TfaCode.vue?vue&type=style&index=0&id=189434d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189434d8",
  null
  
)

export default component.exports